import React from "react";
import {FeatureGroup, GeoJSON, LayersControl, Map, Popup, TileLayer} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";
import Button from "@material-ui/core/Button";
import {ListItemText} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import WebIcon from "@material-ui/icons/Web";
import PersonIcon from "@material-ui/icons/Person";
import LocalPostOfficeIcon from "@material-ui/icons/LocalPostOffice";
import ListItemIcon from "@material-ui/core/ListItemIcon";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

class MapWrapper extends React.Component {

    componentDidMount() {
        this.props.fetchPlaces()
    }

    render() {
        const position = [48.0769, 19.1742];
        return (
            <Map position center={position} zoom={10} style={{ width: "100%"}}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                />
                <GeoJSON key={this.props.path.coordinates.length} data={this.props.path} />
                <LayersControl position="topright">
                    {Object.keys(this.props.places).map((placeCategory, i) =>
                        <LayersControl.Overlay name={placeCategory} checked={true} key={i}>
                            <FeatureGroup>
                                {this.props.places[placeCategory].map((place, i) =>
                                    <GeoJSON data={place.location} key={i}>
                                        <Popup>
                                            <List>
                                                <ListItem>
                                                    <ListItemText primary={place.title} secondary={place.type} />
                                                </ListItem>
                                                <ListItem>
                                                    <img src={place.image} width={244} />
                                                </ListItem>
                                                {place.contact_person && <ListItem>
                                                    <ListItemIcon>
                                                        <PersonIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={place.contact_person} />
                                                </ListItem>}
                                                {place.address_address_line1 && <ListItem>
                                                    <ListItemIcon>
                                                        <LocalPostOfficeIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={place.address_address_line1} secondary={place.address_postal_code + " " + place.address_locality} />
                                                </ListItem>}
                                                {place.telephone_number && <ListItemLink href={"tel:" + place.telephone_number}>
                                                    <ListItemIcon>
                                                        <ContactPhoneIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={place.telephone_number} />
                                                </ListItemLink>}
                                                {place.email && <ListItemLink href={"mailto:" + place.email}>
                                                    <ListItemIcon>
                                                        <ContactMailIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={place.email} />
                                                </ListItemLink>}
                                                {place.link && <ListItemLink href={place.link}>
                                                    <ListItemIcon>
                                                        <WebIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={place.link} />
                                                </ListItemLink>}
                                            </List>
                                            <form onSubmit={e => {
                                                e.preventDefault();
                                                this.props.addPlace(place);
                                            }}>
                                                <Button type="submit" variant={"contained"}>
                                                    Add Place
                                                </Button>
                                            </form>
                                        </Popup>
                                    </GeoJSON>
                                )}
                            </FeatureGroup>
                        </LayersControl.Overlay>
                    )}
                </LayersControl>
            </Map>
        )
    }
}

export default MapWrapper
